const prefix = "";

const paths = {
  about: prefix + "/",
  career: prefix + "/career",
  Experiences: prefix + "/experiences",
  Skills: prefix + "/skills",
  works: prefix + "/works",

};

export { paths }